import type { FC } from "react";
import { useState } from "react";

import Edit from "@/assets/icons/edit";
import PatchPatientIndexesModal from "@/components/modals/patch-patient-indexes-modal";
import type { PatientProps } from "@/components/patient/patient-profile";
import { Button } from "@/components/ui/button";
import RiskLabel from "@/components/ui/risk-label";
import type { Risk } from "@/utils/patient";
import { getRiskColor, getRiskFactors } from "@/utils/patient";

interface RiskFactorCellProps extends PatientProps {
  isProfile?: boolean;
}

const RiskFactorCell: FC<RiskFactorCellProps> = ({
  patient,
  isProfile = false,
}) => {
  const [isPatchIndexModalOpen, setIsPatchIndexModalOpen] = useState(false);

  const riskFactors = getRiskFactors(patient);
  const showDiabetCell = patient.diabetic !== "NONE";
  const showSmokingCell = patient.smoking !== "FALSE";
  const showStressCell = patient.stress !== 1;
  const showGeneticCell = patient.geneticTendency;

  return (
    <div className="flex items-center gap-1">
      {Object.entries(riskFactors).map(([label, value]) =>
        value !== "NONE" ||
        (label === "diabetic" && showDiabetCell) ||
        (label === "smoking" && showSmokingCell) ||
        (label === "stress" && showStressCell) ||
        (label === "geneticTendency" && showGeneticCell) ? (
          <RiskLabel
            risk={label as Risk}
            color={getRiskColor(value)}
            key={`risk-label-${label}`}
          />
        ) : null
      )}
      {isProfile ? (
        <div className="flex gap-1 items-center">
          <div className="font-semibold text-lg pb-2">.</div>
          <div className="text-xs leading-6">{`IP: ${patient.plaqueIndex ? patient.plaqueIndex + "%" : "Inconnu"} - IS: ${patient.bleedingIndex ? patient.bleedingIndex + "%" : "Inconnu"}`}</div>
          <Button
            type="button"
            variant={"text"}
            size={"none"}
            onClick={() => setIsPatchIndexModalOpen(true)}
          >
            <Edit />
          </Button>
        </div>
      ) : null}

      <PatchPatientIndexesModal
        patient={patient}
        isOpen={isPatchIndexModalOpen}
        setIsOpen={setIsPatchIndexModalOpen}
      />
    </div>
  );
};

export default RiskFactorCell;
